import React, { useRef, useState } from 'react';
import useIgnoreRenderEffect from '../../hooks/useIgnoreRenderEffect';
import { Popover, PopoverContent } from '../ui/popover';
import { cn } from '../../lib/utils';
import { addSpanToChildrens } from 'src/utils';

interface Props {
    className?: string;
    children: React.ReactNode;
    style?: React.CSSProperties;
    onClick?: () => void;
    parentElement?: HTMLElement;
    parentId?: string;
    querySelectorId?: string;
    deps: unknown[];
    addSpan?: boolean;
}

function FloatComponent(props: Props) {
    const { className, children, parentElement, parentId, querySelectorId, deps, style, addSpan } = props;

    const [id] = useState(new Date().getTime().toString());
    const [open, setOpen] = React.useState(false);
    const refBuble = useRef<HTMLElement | null>(null);

    const updatePosition = (element: HTMLElement) => {
        const rect = element.getBoundingClientRect();
        const popup = document.getElementById(id)!;
        if (!popup) return;
        popup.style.position = 'fixed';
        popup.style.top = `${rect.top + window.scrollY - rect.height}px`;
        popup.style.left = `${rect.left + window.scrollX + rect.width - 290}px`;
        popup.style.zIndex = '99999999999';
    };

    useIgnoreRenderEffect(
        () => {
            let element: HTMLElement | null = parentElement || null;
            const idBubble = querySelectorId + 'bubble';

            if (querySelectorId) {
                element = document.querySelector(querySelectorId)!;
            } else if (parentId) {
                element = document.getElementById(parentId)!;
            }

            const existBubble = document.getElementById(idBubble);
            if (!element || existBubble) return;

            if (!element.classList.contains('float-bubble-parent')) element.classList.add('float-bubble-parent');
            const newElm = document.createElement('span');
            newElm.id = idBubble;
            newElm.className = cn('float-bubble', className);
            newElm.style.background = (style?.background as string) ?? 'white';
            refBuble.current = newElm;
            newElm.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                setOpen((prevState) => !prevState);
            });

            if (addSpan) addSpanToChildrens(element);

            element.appendChild(newElm);

            return () => {
                newElm?.removeEventListener('click', () => {});
            };
        },
        deps,
        300
    );

    useIgnoreRenderEffect(() => {
        if (open && refBuble.current) {
            updatePosition(refBuble.current!);
        }
    }, [open]);

    return (
        <FloatComponentWithTrigger open={open} setOpen={setOpen} id={id}>
            {children}
        </FloatComponentWithTrigger>
    );
}

export default FloatComponent;

export const FloatComponentWithTrigger = (props: {
    children: React.ReactNode;
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    id: string;
}) => {
    const { children, open, setOpen, id } = props;
    const [hoverable, setHoverable] = useState(true);

    return (
        <Popover open={open} modal>
            <PopoverContent
                onMouseEnter={() => {
                    if (hoverable) setHoverable(false);
                }}
                onMouseLeave={() => {
                    if (!hoverable) {
                        setHoverable(false);
                        setOpen(false);
                    }
                }}
                className="relative rounded-xl px-2 max-h-[500px] overflow-y-auto"
                id={id}
            >
                {children}
            </PopoverContent>
        </Popover>
    );
};
